import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Registro.module.css';

// En desarrollo usa proxy (URL relativa); en producción usa REACT_APP_API_URL
const API_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || '');

export default function Registro() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    cedula: '',
    pais: '',
    ciudad: '',
    especialidad: '',
    correo: '',
    aceptaDatos: false,
  });
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje({ tipo: '', texto: '' });

    if (!formData.aceptaDatos) {
      setMensaje({ tipo: 'error', texto: 'Debe aceptar el tratamiento de datos personales.' });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/registro`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre_completo: formData.nombreCompleto,
          cedula: formData.cedula,
          pais: formData.pais,
          ciudad: formData.ciudad,
          especialidad: formData.especialidad,
          correo: formData.correo,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        if (data.usuario) {
          localStorage.setItem('usuario', JSON.stringify(data.usuario));
          window.dispatchEvent(new CustomEvent('user-login'));
          navigate('/');
        } else {
          setMensaje({ tipo: 'exito', texto: 'Registro exitoso. Gracias por registrarte.' });
          setFormData({
            nombreCompleto: '',
            cedula: '',
            pais: '',
            ciudad: '',
            especialidad: '',
            correo: '',
            aceptaDatos: false,
          });
        }
      } else {
        setMensaje({ tipo: 'error', texto: data.error || 'Error al registrar. Intente de nuevo.' });
      }
    } catch (err) {
      console.error('[Registro] Error de conexión:', err);
      setMensaje({
        tipo: 'error',
        texto: 'No se pudo conectar con el servidor. Verifique que esté en ejecución (cd server && npm run dev).',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.logoWrapper}>
        <div className={styles.logoCircle}>
          <img
            src={`${process.env.PUBLIC_URL}/logo.gif`}
            alt="4to MasterClass EPI"
            className={styles.logoImg}
          />
        </div>
      </div>
      <div className={styles.card}>
        <h1 className={styles.titulo}>Registro de usuario</h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="nombreCompleto">Nombre completo*</label>
            <input
              id="nombreCompleto"
              name="nombreCompleto"
              type="text"
              value={formData.nombreCompleto}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="cedula">Cédula*</label>
            <input
              id="cedula"
              name="cedula"
              type="text"
              value={formData.cedula}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="pais">País*</label>
            <input
              id="pais"
              name="pais"
              type="text"
              value={formData.pais}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="ciudad">Ciudad*</label>
            <input
              id="ciudad"
              name="ciudad"
              type="text"
              value={formData.ciudad}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="especialidad">Especialidad*</label>
            <input
              id="especialidad"
              name="especialidad"
              type="text"
              value={formData.especialidad}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.field}>
            <label htmlFor="correo">Correo electrónico*</label>
            <input
              id="correo"
              name="correo"
              type="email"
              value={formData.correo}
              onChange={handleChange}
              required
            />
          </div>
          <p className={styles.obligatorios}>* Campos obligatorios</p>
          <div className={styles.checkboxField}>
            <input
              id="aceptaDatos"
              name="aceptaDatos"
              type="checkbox"
              checked={formData.aceptaDatos}
              onChange={handleChange}
              required
            />
            <label htmlFor="aceptaDatos">
              Acepto la{' '}
              <a
                href={`${process.env.PUBLIC_URL}/politica-tratamiento-datos.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.policyLink}
                onClick={(e) => e.stopPropagation()}
              >
                política de tratamiento de datos personales
              </a>
              .
            </label>
          </div>
          {mensaje.texto && (
            <p className={mensaje.tipo === 'exito' ? styles.mensajeExito : styles.mensajeError}>
              {mensaje.texto}
            </p>
          )}
          <button type="submit" className={styles.boton} disabled={loading}>
            {loading ? 'Enviando...' : 'Registrarse'}
          </button>
        </form>
      </div>
    </section>
  );
}
